import { useEffect, useRef, useCallback } from 'react';

const useScrollPosition = () => {
  const scrollPosition = useRef(window.scrollY);

  const handleScroll = useCallback(() => {
    scrollPosition.current = window.scrollY;
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  const getScrollPosition = useCallback(() => scrollPosition.current, []);

  const setScrollPosition = useCallback((position: number) => {
    scrollPosition.current = position;
    window.scrollTo(0, position);
  }, []);

  return { getScrollPosition, setScrollPosition };
};

export default useScrollPosition;
